import { Tag, TagLabel } from "@chakra-ui/react";

export default function ArchivedTag() {
  return (
    <Tag size="sm" variant="solid" colorScheme="gray">
      <TagLabel>Archived</TagLabel>
    </Tag>
  );
}
